import React from 'react';
import clinicData from '../data/clinicData.json';

const AppointmentOnline = () => {
  return (
    <div className="bg-gradient-to-br from-cream to-sage overflow-auto">
      <div className="bg-white shadow-md">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <h1 className="text-2xl sm:text-3xl font-bold gradient-text text-center">Online Consultation</h1>
          <p className="text-gray-600 text-center mt-2">Book your online appointment with Dr. Vrushali Ghate</p>
        </div>
      </div>

      <div className="py-8 px-4">
        <div className="max-w-4xl mx-auto space-y-6">
          <div className="bg-white rounded-2xl shadow-2xl p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Payment Instructions</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <p className="text-gray-700">{clinicData.contact.onlinePayment.instructions}</p>
                <p className="text-2xl font-bold text-green-600">{clinicData.contact.onlinePayment.amount}</p>
                <p className="text-xl font-bold text-forest">{clinicData.contact.onlinePayment.upiId}</p>
                <p className="text-gray-700">
                  {clinicData.contact.onlinePayment.afterPayment}{' '}
                  <a 
                    href={clinicData.contact.onlinePayment.whatsappUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-green-600 font-bold hover:underline"
                  >
                    7798702512
                  </a>.
                </p>
                <p className="text-gray-700">{clinicData.contact.onlinePayment.meetingInfo}</p>
                <p className="text-red-600 font-medium">{clinicData.contact.onlinePayment.timeLimit}</p>
              </div>
              <div className="flex justify-center">
                <img 
                  src={clinicData.contact.onlinePayment.qrImage} 
                  alt="Payment QR Code" 
                  className="w-64 h-64 sm:w-80 sm:h-80 object-contain rounded-lg shadow-md"
                />
              </div>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-2xl p-6">
            <iframe 
              src={clinicData.contact.appointmentUrlOnline}
              width="100%" 
              height="800" 
              frameBorder="0" 
              scrolling="yes"
              className="rounded-lg min-h-screen"
              style={{minHeight: '100vh'}}
              title="Online Appointment Booking Calendar"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentOnline;